import React, { useState,useEffect } from "react";
import Header from '../../layout/header';
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import BottomMenu from "../../layout/bottomMenu";
import NotFoundData from "../../../Images/no-data-found.webp";
import Moment from "moment/moment";

const SitesCallingLog = ({
    getReferralCallLogs,
    referralCallLog=[],
    match
}) => {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        let webView = localStorage.getItem('webview');
        if(webView !== undefined && webView == 'true') {
            const message = {
                event_name: 'screenshot_prevent',
                page_name: 'yes',
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                setTimeout(function () {
                    nativeObject.postMessage(JSON.stringify(message));
                    window.addEventListener('message', () => {
                    })
                  }, 100);
            }
        }
    }, []);

    useEffect(() => {
        (async () => {
            if(match.params.id!=undefined&&match.params.id!=null&&match.params.id!=''){
                setIsLoading(true)
                await getReferralCallLogs(match.params.id)
                setIsLoading(false)
            }
        })()
    }, [])


    return (
        <>
                  <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Site Calling Logs'}
                        />
                        {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row">
                                    {/*CARD START*/}
                                    {referralCallLog && referralCallLog?.data?.length > 0 && referralCallLog.data.map((val, i) => (
                                        <div key={i} className="col-lg-4 col-md-6 col-12">
                                            <div className="card-big-shadow">
                                                <div className="card card-just-text p-3" style={{
                                                    borderRadius: '10px',
                                                    backgroundColor: '#f8f9fa',
                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                                }}>
                                                    <div className="content" style={{ padding: "initial" }}>
                                                    <h6 className="category mrg-b-12">
                                                            <div className="list-view" style={{ margin: "auto" }}>
                                                                <div className="row mb-2" style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <div className="col-6 d-flex align-items-center" style={{ minWidth: "150px", textAlign: "left" }}>
                                                                        <i className="bi bi-calendar-check text-info"></i>&nbsp;<strong>{'Call Date'}</strong>
                                                                    </div>
                                                                    <div className="col-6 d-flex align-items-center justify-content-end" style={{ textAlign: "right" }}>
                                                                        <span>{val.call_date}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2" style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <div className="col-6 d-flex align-items-center" style={{ minWidth: "150px", textAlign: "left" }}>
                                                                        <i className="bi bi-person-fill text-secondary"></i>&nbsp;<strong>{'Form filled By:'}</strong>
                                                                    </div>
                                                                    <div className="col-6 d-flex align-items-center justify-content-end" style={{ textAlign: "right" }}>
                                                                        <span>{val.referred_by_name}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2" style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <div className="col-6 d-flex align-items-center" style={{ minWidth: "150px", textAlign: "left" }}>
                                                                        <i className="bi bi-clock-fill text-danger"></i>&nbsp;<strong>{'Form filled at'}</strong>
                                                                    </div>
                                                                    <div className="col-6 d-flex align-items-center justify-content-end" style={{ textAlign: "right" }}>
                                                                        <span>{val.call_date_time}</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <hr style={{ borderTop: '1px solid #ddd', margin: '10px 0' }} />

                                                            <div className="list-view" style={{ margin: "auto" }}>
                                                                {[
                                                                    { label: 'Caller Name', icon: 'bi-people-fill text-warning', value: val.caller_poc_name },
                                                                    { label: 'Caller Number', icon: 'bi-telephone-fill text-warning', value: val.caller_poc_number },
                                                                    { label: 'Caller Email', icon: 'bi-envelope-fill text-warning', value: val.caller_poc_email || 'N/A' },
                                                                    { label: 'Caller Designation', icon: 'bi-award-fill text-success', value: val.caller_poc_designation },
                                                                    { label: 'Receiver Name', icon: 'bi-person-fill text-danger', value: val.receiver_poc_name },
                                                                    { label: 'Receiver Number', icon: 'bi-telephone-fill text-danger', value: val.receiver_poc_number },
                                                                    { label: 'Receiver Email', icon: 'bi-envelope-fill text-danger', value: val.receiver_poc_email },
                                                                    { label: 'Receiver Designation', icon: 'bi-award-fill text-primary', value: val.receiver_poc_designation }
                                                                ].map((item, idx) => (
                                                                    <div key={idx} className="row mb-2" style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center"
                                                                    }}>
                                                                        <div className="col-6 d-flex align-items-center" style={{ minWidth: "150px", textAlign: "left", whiteSpace: "nowrap" }}>
                                                                            <i className={`bi ${item.icon}`}></i>&nbsp;<span>{item.label}</span>
                                                                        </div>
                                                                        <div className="col-6 d-flex align-items-center justify-content-end" style={{ textAlign: "right" }}>
                                                                            <span className="trigger"
                                                                                          data-tooltip-id="1">{item.value}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {/* {referralCallLog && referralCallLog?.data !== undefined && referralCallLog?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(referralCallLog?.total / referralCallLog?.per_page)}
                                                forcePage={referralCallLog?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    } */}

                                    {referralCallLog && referralCallLog?.data !== undefined && referralCallLog?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data"/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* section ends */}
        </>
        </>
      );
};

export default SitesCallingLog;